export const uniqueArrayValues = (array): any[] => Array.from(new Set(array));
